<template>
  <div>
    <div class="page-head">
      <div>
        <h3>Order History</h3>
        <p class="page-head-sub">Poland orders closed on a given day</p>
      </div>
    </div>
    <div class="toolbar">
      <div class="toolbar-field" style="max-width: 280px">
        <label>Order closed date</label>
        <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="startDate" class="text-dark"></datepicker>
      </div>
      <button @click="getOrders" :class="!startDate ? 'btn-secondary disabled' : 'btn-primary'" class="btn px-4">
        <b-icon-search class="mr-2"></b-icon-search>Search
      </button>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <div v-if="data.length">
      <div class="row mx-0 overflow-auto">
        <div class="w-100">
          <table class="table orders-table" ref="articles">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Added</th>
              <th scope="col">SKU</th>
              <th class="d-none d-sm-table-cell" scope="col">SSKU</th>
              <th class="d-none d-sm-table-cell" scope="col">Factory #</th>
              <th class="d-none d-sm-table-cell" scope="col">Ordered</th>
              <th class="d-none d-sm-table-cell" scope="col">Scanned</th>
              <th class="d-none d-sm-table-cell text-center" scope="col">Ordered For</th>
              <th class="d-none d-sm-table-cell" scope="col">Notes</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(val, i) of data">
              <!-- Gap between order cards; groups start where getOrders set `border` -->
              <tr v-if="val.border && i > 0" class="group-gap" :key="`gap-${i}`" aria-hidden="true">
                <td colspan="9"></td>
              </tr>
              <tr v-if="val.border" class="separator" :key="`conditional-${i}`">
                <td colspan="9" class="w-100 group-row-cell">
                  <span>Ordered by: <span class="text-uppercase">{{val.fromWeb ? 'website' : val.user && val.user.username || 'Lyngdal'}}</span></span>
                  <span v-if="val.fromWeb && val.deliveryMethod" class="ml-3 float-right">Delivery method: {{val.deliveryMethod.name}}</span>
                </td>
              </tr>
              <tr :key="i" :class="['article-row', getRowClass(val), { 'group-last': i === data.length - 1 || data[i + 1].border }]">
                <td :style="scanned.code && val.ean && val.ean.includes(scanned.code) ? 'background: var(--accent); color: #ffffff' : ''">{{i+1}}</td>
                <th scope="row">{{moment(val.addedAt).format('DD.MM.YYYY')}}</th>
                <td>{{val.sku}}</td>
                <td>{{val.ssku}}</td>
                <td>{{val.num}}</td>
                <td class="text-center">{{val.count}}</td>
                <td class="text-center">{{val.confirmed || 0}}</td>
                <td class="text-center">{{val.metaData || 'WORKSHOP'}}</td>
                <td v-b-tooltip.hover.left="val.notes ? stripHtmlTags(val.notes) : ''" class="text-center" @click="openNotes(val)">
                  <b-icon icon="pencil-square" class="pointer"></b-icon>
                </td>
              </tr>
            </template>

            </tbody>
          </table>
        </div>
      </div>
<!--      <div class="row overflow-hidden d-flex">-->
<!--        <div class="col-md-6 col-sm-6 ml-auto">-->
<!--          <table class="table font-weight-bolder float-right">-->
<!--            <tr>-->
<!--              <td>TOTAL ORDER VALUE:</td>-->
<!--              <td class="text-right">{{totalPrice.toFixed(2).toLocaleString('en')}} PLN</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td>TOTAL PIECES:</td>-->
<!--              <td class="text-right">{{totalCount}}</td>-->
<!--            </tr>-->
<!--          </table>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div v-else class="empty-state">
      <b-icon-clock-history></b-icon-clock-history>
      Select a day to search the order history
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '@/fixed';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  name: 'MerchantOrderHistory',
  data: () => ({
    user: null,
    loading: false,
    data: [],
    startDate: null,
    scanned: { order: '', code: '' },

    moment,
  }),
  async created() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  methods: {
    async getOrders() {
      if (!this.startDate) return;
      this.loading = true;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/merchant/merchant-history?day=${moment(this.startDate).format('yyyy-MM-DD')}&user=${this.user.id}`,
          { withCredentials: true },
        );

        if (data && data.length) {
          // Group case-insensitively by metaData. Lines without one are shown
          // as WORKSHOP, so they sort and group with the WORKSHOP lines.
          const groupKey = (row) => (row.metaData || 'WORKSHOP').toLowerCase();

          // assign response to data
          this.data = data.sort((a, b) => {
            if (groupKey(a) < groupKey(b)) return -1;
            if (groupKey(a) > groupKey(b)) return 1;
            return 0;
          });

          // client separator class flag
          this.data.forEach((row, i) => {
            if (i === 0 || groupKey(row) !== groupKey(this.data[i - 1])) {
              this.data[i].border = true;
            }
          });
        } else {
          throw new Error('No data for selected params');
        }
      } catch (error) {
        this.data = [];
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻');
        } else {
          this.$toast.error(error?.message); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    getRowClass(row) {
      if (row.notes && !row.noteType) return 'bg-primary';
      if (row.notes && row.noteType === 1) return 'wrong-ean text-white';
      if (row.notes && row.noteType === 2) return 'unavailable-goods text-white';
      if (row.notes && row.noteType === 3) return 'goods-replaced-with text-dark';
      if (row.notes && row.noteType === 4) return 'bg-warning text-dark';

      if (row.count === row.confirmed) return 'bg-success text-dark';
      if (row.count < row.confirmed) return 'bg-warning text-dark';
      return '';
    },
    stripHtmlTags(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
  },
};
</script>

<style>

</style>
